<script src="product-media.component.ts"></script>
<section class="product-media-section">
  <div class="add-media-container" *ngIf="!mediaFiles.length;else mediaList">
    <div class="add-media-link-container" (click)="openProductImages()">
      <div class="add-media-image">
        <i class="db-icon db-icon-ds-img-border"></i>
      </div>
      <div class="add-media-text">{{ 'text_addProductImages' | dbText }}</div>
    </div>
  </div>
  <ng-template #mediaList>
    <div class="media-files-container">
      <div class="title-container">
        <div class="container-title">
          {{ 'text_productImages' | dbText }}
        </div>
        <div class="container-action-link" (click)="openProductImages()">
          {{ 'text_manageProductImages' | dbText }}
        </div>
      </div>
      <div class="media-files-list">
        <div class="main-image-container">
          <div class="main-image">
            <img class="media-item" [src]="mediaFiles[0].src || mediaFiles[0].source_url" alt="image">
            <div class="main-image-chip">
              {{ 'text_mainImage' | dbText }}
            </div>
          </div>
        </div>
        <div class="secondary-images-container" *ngIf="mediaFiles.length > 1">
          <div class="secondary-image" *ngFor="let item of mediaFiles |slice:1; let i = index">
            <img class="media-item" [src]="item.src || item.source_url" alt="image">
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <div class="ds-notification-error mt5" *ngIf="imageUploadError">
    <div>
      <i class="db-icon db-icon-ds-info-bg"></i>
      <p [innerHTML]="imageUploadError"></p>
    </div>
  </div>
</section>
